import InfoIcon from "@material-ui/icons/Info";
import SettingsIcon from "@material-ui/icons/Settings";
import { IRoute } from "src/common/typings/routes";
import { Configuration } from "./Management";
import { DeletedRecords } from "./modules/deleted-records/DeletedRecords";
import { AssignPermissions } from "./modules/roles/pages/AssignPermissions/AssignPermissions";
import { ListRoles } from "./modules/roles/pages/ListRoles";
import { AddNewUser } from "./modules/users/pages/AddNewUser";
import { ListUsers } from "./modules/users/pages/ListUsers/index";
import { UpdateUser } from "./modules/users/pages/UpdateUser";
import { General } from "./modules/general/General";
import { ListApprovals } from "./modules/Approvals";
import { WebocData } from "./modules/weboc-data";
import { HoldUnholdContainer } from "./modules/hold-unhold-containers";

export const ManagementRoute: IRoute = {
  title: "Management",
  path: "/nod/management",
  icon: SettingsIcon,
  component: Configuration,
  guard: true,
  subRoutes: [
    { icon: InfoIcon, component: General, path: "/general", title: "General" },
    { icon: InfoIcon, component: ListUsers, path: "/list-users", title: "List of Users" },
    { icon: InfoIcon, component: ListRoles, path: "/roles", title: "List of Roles" },
    {
      icon: InfoIcon,
      component: DeletedRecords,
      path: "/deleted-records",
      title: "List of Deleted Records",
    },
    {
      icon: InfoIcon,
      component: AddNewUser,
      path: "/add-user",
      title: "Add New User",
      noDrawer: true,
    },
    {
      component: UpdateUser,
      path: "/update-user",
      pathParam: "/:id",
      title: "Update User",
      noDrawer: true,
    },
    {
      component: AssignPermissions,
      path: "/assign-permissions",
      pathParam: "/:id/:terminalId",
      title: "Assign Permissions",
      noDrawer: true,
    },
    {
      icon: InfoIcon,
      component: ListApprovals,
      path: "/approvals",
      title: "List of Approvals",
      noDrawer: false,
    },
    {
      icon: InfoIcon,
      component: WebocData,
      path: "/weboc-gd-status",
      title: "WeBOC GD Status",
      noDrawer: false,
    },
    {
      icon: InfoIcon,
      component: HoldUnholdContainer,
      path: "/hold-unhold-container",
      title: "Hold/UnHold Containers",
      noDrawer: false,
    },
  ],
};
